import api from 'services/api';

interface User {
  user_hash_id: string;
  object_type: 'user' | 'person'; // Replace with actual possible values
}

// export const updateTimelineSummary = async (
//   videoHashId: string,
//   shotId: string,
//   timelineId: string,
//   summary: string
// ): Promise<any> => {
//   const response = await api.patch(`/api/videos/${videoHashId}/shots/${shotId}/timelines/${timelineId}/`, {
//     summary: summary
//   });
//   return response;
// };

export const updateTimelineContent = async (
  videoHashId: string,
  shotId: string,
  timelineId: string,
  data: { summary?: string; title?: string; highlighted_text?: string }
): Promise<any> => {
  const response = await api.patch(`/api/videos/${videoHashId}/shots/${shotId}/timelines/${timelineId}/`, data);
  return response;
};

export const updateTimelineSpeaker = async (
  videoHashId: string,
  shotId: string,
  timelineId: string,
  user: User
): Promise<any> => {
  const response = await api.put(`/api/videos/${videoHashId}/shots/${shotId}/timelines/${timelineId}/`, {
    hash_id: user.user_hash_id,
    object_type: user.object_type
  });
  return response;
};

export const removeTimeline = async (videoHashId: string, shotId: string, timelineId: string): Promise<any> => {
  const response = await api.delete(`/api/videos/${videoHashId}/shots/${shotId}/timelines/${timelineId}/`);
  return response;
};

export const addTimelineSummary = async (
  videoHashId: string,
  shotId: string,
  content: string,
  timestamp: number
): Promise<any> => {
  const response = await api.post(`/api/videos/${videoHashId}/shots/${shotId}/timelines/`, {
    summary: content,
    timestamp: timestamp
  });
  return response;
};

export const removeTimelineSpeaker = async (
  videoHashId: string,
  shotId: string,
  timelinehashId: string
): Promise<any> => {
  const response = await api.delete(`/api/videos/${videoHashId}/shots/${shotId}/timelines/${timelinehashId}/speaker/`);
  return response;
};
